export default __webpack_public_path__ + "static/media/52_desktop.a17644d8.jpg";